export const getTopTracksFromAlbums = (albums: Album[]): number[] => {
	return albums.reduce((albumTrackIds, currentAlbum) => {
		if (currentAlbum.topTrackId) {
			albumTrackIds.push(currentAlbum.topTrackId)
		}
		return albumTrackIds
	}, [])
}
